import { render, staticRenderFns } from "./resource-video-popup.vue?vue&type=template&id=3bda4c19&scoped=true&"
import script from "./resource-video-popup.vue?vue&type=script&lang=js&"
export * from "./resource-video-popup.vue?vue&type=script&lang=js&"
import style0 from "./resource-video-popup.vue?vue&type=style&index=0&id=3bda4c19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bda4c19",
  null
  
)

component.options.__file = "resource-video-popup.vue"
export default component.exports